import request from '@/utils/request'

// 账号管理列表
export function getPunchAccountList(data) {
  return request({
    url: '/admin/enterprise/list',
    method: 'post',
    params: data
  })
}

// 账号管理ids接口
export function getPunchAccountIds(data) {
  return request({
    url: '/admin/enterprise/ids',
    method: 'post',
    params: data
  })
}

// 所在公司
export function getFindCompanyByIds(data) {
  return request({
    url: '/admin/enterprise/findCompanyByIds',
    method: 'post',
    params: data
  })
}

// 搜索公司
export function getSearchCompanyByName(data) {
  return request({
    url: '/admin/enterprise/searchCompanyByName',
    method: 'post',
    params: data
  })
}

// 保存
export function getSaveInfo(data) {
  return request({
    url: '/admin/enterprise/save',
    method: 'post',
    params: data
  })
}

// 更新
export function getUpdateInfo(data) {
  return request({
    url: '/admin/enterprise/update',
    method: 'post',
    params: data
  })
}

// 删除
export function getDeleteInfo(data) {
  return request({
    url: '/admin/enterprise/delete',
    method: 'post',
    params: data
  })
}

// 打卡记录列表
export function getPunchLogList(data) {
  return request({
    url: '/admin/punchLog/list',
    method: 'post',
    params: data
  })
}

// 打卡汇总列表
export function getPunchTotalsList(data) {
  return request({
    url: '/admin/punchTotals/list',
    method: 'post',
    params: data
  })
}

